export default __webpack_public_path__ + "static/media/icon-3.f6c7585b.png";